import { arrayToTree } from "performant-array-to-tree";
import {
  CAMPAIGN_LOADING,
  CAMPAIGN_ERROR,
  SET_CAMPAIGNS,
  SELECT_CAMPAIGN,
  DELETE_CAMPAIGN,
  SET_CAMPAIGN_TEMPLATES,
  SELECT_FOLDER,
  SET_CAMPAIGN_FOLDERS,
  SET_NESTED_CAMPAIGN_FOLDERS,
  REPORT_REFRESHED,
  RESET_CAMPAIGNS,
  CALLER_ID_USAGE_DETAILS,
  SET_EMAIL_OPTIONS,
  SET_PUSH_OPTIONS,
  WAV_FILE_UPLOAD,
  REMOVE_WAV_FILE,
  LOAD_SAVED_FILES,
  REMOVE_FILES,
  SET_CAMPAIGN_TAGS,
} from "../constants";

const initial_state = {
  loading: {},
  errors: {},
  list: [],
  selected: {},
  templates: [],
  folders: [],
  callerIds: [],
  emailOptions: {},
  pushOptions: {},
  selectedFolder: {},
  nestedFolders: [],
  nestedCampaignFolders: [],
  files: [], // Array of File object
  tags_list: [],
};

export default function (state = initial_state, { type, payload }) {
  const { loading, errors, files } = state;

  switch (type) {
    case CAMPAIGN_ERROR:
      return {
        ...state,
        errors: payload || { unknown: "Unknown error" },
      };

    case CAMPAIGN_LOADING:
      loading[payload] = true;

      return {
        ...state,
        loading,
      };

    case SET_CAMPAIGNS:
      return {
        ...state,
        list: payload,
      };

    case SELECT_CAMPAIGN:
      return {
        ...state,
        selected: payload,
      };

    case DELETE_CAMPAIGN:
      delete errors.delete;

      return {
        ...state,
        errors,
      };

    case SET_CAMPAIGN_TEMPLATES:
      return {
        ...state,
        templates: payload,
      };

    case SELECT_FOLDER:
      return {
        ...state,
        selectedFolder: payload || {},
      };

    case SET_CAMPAIGN_FOLDERS:
      loading["campaign_folders"] = false;

      const nestedFolders = arrayToTree(payload, {
        id: "folder_id_bint",
        parentId: "parentid_bi",
      });
      return {
        ...state,
        loading,
        folders: payload,
        nestedFolders,
      };

    case SET_CAMPAIGN_TAGS:
      loading["campaign_tags"] = false;

      return {
        ...state,
        loading,
        tags_list: payload,
      };

    case SET_NESTED_CAMPAIGN_FOLDERS:
      loading["nested_campaign_folders"] = false;

      const nestedCampaignFolders = arrayToTree(payload, {
        id: "folder_id_bint",
        parentId: "parentid_bi",
      });

      return {
        ...state,
        loading,
        nestedCampaignFolders,
      };

    case SET_EMAIL_OPTIONS:
      delete errors.emailOptions;

      return {
        ...state,
        errors,
        emailOptions: payload,
      };

    case SET_PUSH_OPTIONS:
      delete errors.pushOptions;

      return {
        ...state,
        errors,
        pushOptions: payload,
      };

    case REPORT_REFRESHED:
      delete loading.report;

      return {
        ...state,
        loading,
      };

    case RESET_CAMPAIGNS:
      return { ...initial_state };
    case CALLER_ID_USAGE_DETAILS:
      return {
        ...state,
        caller_id_usage_details: payload || [],
      };

    case WAV_FILE_UPLOAD:
      // Prevent duplicate files from populating
      const stored = new Set(files.map((file) => file.name));
      payload = payload.filter((file) => !stored.has(file.name) && stored.add(file.name));

      return {
        ...state,
        files: !payload.length ? [] : [...files, ...payload],
      };
    case LOAD_SAVED_FILES:
      return {
        ...state,
        files: [...payload],
      };
    case REMOVE_FILES:
      return {
        ...state,
        files: [],
      };

    case REMOVE_WAV_FILE:
      // Uses { files } = state; from above
      let fileArr = [];
      if (payload && payload.length) {
        for (let fileObj of payload) {
          const file = files.filter((file) => file.name !== fileObj.name);
          fileArr.push(...file);
        }
      }
      //const filtered_files = files.filter((file) => file.name !== payload.name);

      return {
        ...state,
        files: fileArr,
      };

    default:
      return state;
  }
}
